export default __webpack_public_path__ + "static/media/3366.88298b2a.png";